import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AssessmentAgeBandManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/assessment-age-bands")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AssessmentAgeBandManagement />
    </RouteGuard>
  ),
});
